import { render, staticRenderFns } from "./CreateDoctor.vue?vue&type=template&id=e810d1ca&"
import script from "./CreateDoctor.vue?vue&type=script&lang=js&"
export * from "./CreateDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports